import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

import { observeAuthIdentity, resetAuthCache } from "./query-identity";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "",
  fetchOptions: {
    onRequest(context) {
      const path = new URL(String(context.url), typeof window !== "undefined" ? window.location.origin : "http://localhost").pathname;
      if (/\/(sign-in|sign-up|sign-out|delete-user)(\/|$)/.test(path)) resetAuthCache();
    },
    onSuccess(context) {
      const path = new URL(String(context.request.url), typeof window !== "undefined" ? window.location.origin : "http://localhost").pathname;
      if (/\/(sign-in|sign-up|sign-out|delete-user)(\/|$)/.test(path)) resetAuthCache(true);
      if (path.endsWith("/get-session")) observeAuthIdentity(context.data?.user?.id ?? null);
    },
  },
  plugins: [emailOTPClient()],
});
